module.exports = {
  messages: {
    CN: {
      "yes": '是',
      "no": '否',
      "emailAction": '操作',
      account: {
        groupName: '分组名称',
        EnableMessage: '确定要删除吗？',
        rule: '请输入分组名称',
        sarchValuePl: '搜索商品编号或名称',
        selectGroup: '选择商品',
        goodsPlaceholder: '请输入商品名称',
        emptyGoodsTip: '请选择筛选条件后查询商品',
        noGoods: '暂无数据',
        selected: '已选：商品',
        goodsName: '商品名称',
        goodsNumber: '商品编号',
        total: '总条数：',
        total2: '合计：',
        message1: '列表存在终卖的商品，请删除后重试',
        delete: '删除',
        edit: '编辑',
        searchContent: '商品信息',
        searchPl: '请输入商品编号或名称',
        goodsCount: '商品数量',
        createUser: '创建者',
        updateTime: '更新时间',
        editGoods: '编辑商品分组',
        goodsCla: '商品分类',
        goodsGroup: '商品分组',
        srx: '仕入先',
        janPleaseholder: '请输入JAN'
      }
    },
    JP: {
      "yes": 'はい',
      "no": 'いいえ',
      "emailAction": '操作',
      account: {
        groupName: 'グループ名',
        EnableMessage: '削除してもよろしいですか？',
        rule: 'グループ名を入力してください',
        sarchValuePl: '商品コードまたは名前を検索',
        selectGroup: '商品を選択',
        goodsPlaceholder: '商品名を入力してください',
        emptyGoodsTip: '商品を検索する前にフィルター条件を選択してください',
        noGoods: 'データなし',
        selected: '選択済み：商品',
        goodsName: '商品名',
        goodsNumber: '商品コード',
        total: '総数：',
        total2: '合計：',
        message1: 'リストには終売の商品が存在します。削除してから再試行してください',
        delete: '削除',
        edit: '編集',
        searchContent: '商品情報',
        searchPl: '商品コードまたは名前を入力してください',
        goodsCount: '商品数量',
        createUser: '作成者',
        updateTime: '更新時間',
        editGoods: '商品グループの編集',
        goodsCla: '商品カテゴリー',
        goodsGroup: '商品グループ',
        srx: '仕入先',
        janPleaseholder: 'JANを入力してください'
      }
    }
  }
};